/*
    Endeca configuration for the mobile search page endeca instance.

    See comments in PC search page endeca instance

*/

var site = site || {};
var generic = generic || {};
site.endeca = site.endeca || {};
site.endeca.instances = site.endeca.instances || {};
site.endeca.instances.search = site.endeca.instances.search || {};


jQuery(document).ready(function(){
    site.endeca.instances.search.configuration = jQuery.extend( true, {}, site.endeca.configuration, {

        followRedirects: true,

        contentzones: {
            "Top Banner": {
                "node"                          : jQuery('.search-wrapper__banner'),
                "counted"                       : false,
                "solo"                          : false
            },
            "Bottom Banner": {
                "node"                          : jQuery('.search-wrapper__bottom_banner'),
                "counted"                       : false,
                "solo"                          : false
            },
            "Related Content": {
                "node"                          : jQuery('.search-wrapper__related_content'),
                "counted"                       : true,
                "solo"                          : true
            }
        },

        noResultsContentZone: {
            "Zero Search Results": {
                "node"                          : jQuery('.search-wrapper__no_results'),
                "counted"                       : false,
                "solo"                          : true
            }
        },

        nodes: {
            loading: jQuery('#loading')
        },

        mixins: {
            "result": site.endeca.mixins.links.address,
            "results.products":  site.endeca.mixins.summary,
            "results.pagination": site.endeca.mixins.selectbox,
            "results.refinements": site.endeca.mixins.accordion,
            "resultsgroup.refinements": site.endeca.mixins.accordion
        },

        queries: {
            product: {
                recordFilters: ['activeSkus', 'products'],
                rangeFilters: ['skuShoppable']
            }
        },

        results: {
            products: {
                baseClass: 'site.endeca.results',
                instanceArgs: {
                    parentNode: jQuery('#product-results')
                },
                configuration: {
                    maxmimumShades: 4,
                    summaryTemplatePath: '/templates/endeca/products/summary.tmpl'
                }
            },
            
            content: {
                baseClass: 'site.endeca.resultsgroup',
                childClass: 'site.endeca.resultsgroup.contentzones'
            },

            refinements: {
                baseClass: 'site.endeca.resultsgroup',
                instanceArgs: {
                    parentNode: jQuery('#refinements')
                }
            },

            breadcrumbs: {
                baseClass: 'site.endeca.resultsgroup',
                instanceArgs: {
                    parentNode: jQuery('#breadcrumbs'),
                    resultsArgs: {
                        templatePath: '/templates/endeca/breadcrumbs/link.tmpl'
                    }
                }
            },

            summary: {
                baseClass: 'site.endeca.result',
                instanceArgs: {
                    parentNode: jQuery('#search-summary')
                }
            },

            pagination: {
                baseClass: 'site.endeca.resultsgroup',
                configuration: {
                    noScroll: 1,
                    containerTemplatePath: '/templates/endeca/pagination/page-container.tmpl',
                    viewAllLink: true,
                    nextPageLink: true,
                    previousPageLink: true
                }
            },

            bestsellers: {
                baseClass: 'site.endeca.results',
                instanceArgs: {
                    parentNode: jQuery('#bestseller-results'),
                    templatePath: "/templates/endeca/products/result.tmpl"
                },
                configuration: {
                    queryArgs: {
                        recordsPerPage: 100,
                        searchKey: 'p_ALL_CAT_IDS',
                        searchTerm: 'CAT1575'
                    },
                    maxmimumShades: 4
                }
            }
        }
    });

    site.endeca.instances.search.configuration.query.defaultDimensionIds = [8061,8062,8127,8050,8063,8053,8089,8051,8095,8096,8147,8052,8054,8219];

    new site.endeca.instances.search.control( site.endeca.instances.search.configuration );

  jQuery.extend(generic.endeca.result.product, {
    setupBrandData: function() {
      this.resultData.formattedCartridgePrice = typeof this.resultData.GIFTSET_COMPONENTS != 'undefined' ? this.resultData.skus[0].formattedCartridgePrice : '';
    },
  });
});
